module.exports = __webpack_public_path__ + "img/process_small.98fc2185.jpg";